// src/components/StarQuestBar.jsx
import React from "react";

const TOTAL_STARS = 8;

export default function StarQuestBar({
  completedLevels = [],
  doronImageSrc,
  starImages = [],          // array length 8, bottom->top order
  getSlotEl = null,         // callback(bottomIndex, el)
  newlyEarnedBottomIndex = null, // highlight one slot
  className = "",
}) {
  const earned = Math.min(
    Math.max(0, Array.isArray(completedLevels) ? completedLevels.length : 0),
    TOTAL_STARS
  );

  const slotsFromTop = Array.from({ length: TOTAL_STARS }, (_, visualIndex) => {
    const bottomIndex = TOTAL_STARS - 1 - visualIndex;
    const filled = bottomIndex < earned;
    return { visualIndex, bottomIndex, filled };
  });

  return (
    <div className={"flex flex-col items-center justify-start " + className}>
      {doronImageSrc && (
        <div className="mb-3">
          <img
            src={doronImageSrc}
            alt="Doron"
            className="h-20 w-auto md:h-24 object-contain drop-shadow-lg"
          />
        </div>
      )}

      <div className="relative bg-white/95 border border-slate-200 shadow-[0_10px_25px_rgba(15,23,42,0.18)] rounded-[999px] px-4 py-4 flex flex-col items-center justify-between gap-3 min-h-[270px]">
        {slotsFromTop.map(({ visualIndex, bottomIndex, filled }) => {
          const imgSrc = starImages?.[bottomIndex];
          const isNew = newlyEarnedBottomIndex === bottomIndex;

          // ✅ circle size unchanged
          const baseCircle =
            "w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center border-2 transition-all bg-white relative";
          const stateCircle = filled
            ? "border-amber-400 bg-gradient-to-b from-amber-200 to-amber-400 shadow-md"
            : "border-slate-200 bg-slate-50";

          const newRing = isNew
            ? "ring-4 ring-yellow-300 animate-[pulse_0.9s_ease-in-out_2]"
            : "";

          return (
            <div
              key={visualIndex}
              ref={(el) => getSlotEl?.(bottomIndex, el)}
              className={`${baseCircle} ${stateCircle} ${newRing}`}
            >
              {filled ? (
                imgSrc ? (
                  // ✅ bigger star INSIDE the same circle
                  <img
                    src={imgSrc}
                    alt="Star"
                    className="w-8 h-8 md:w-9 md:h-9 object-contain"
                    draggable={false}
                  />
                ) : (
                  <span className="text-base md:text-lg font-black text-amber-700">
                    ★
                  </span>
                )
              ) : (
                <span className="text-base md:text-lg font-black text-slate-300">
                  ★
                </span>
              )}

              {/* ✅ slightly bigger sparkle overlay when new */}
              {isNew && (
                <span className="absolute -top-1 -right-1 text-sm md:text-base">
                  ✨
                </span>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-2 text-[8px] md:text-[9px] uppercase tracking-[0.18em] text-slate-500 text-center">
        <span className="font-bold text-slate-700">{earned}/{TOTAL_STARS}</span>{" "}
        stars
        <br />
        collected
      </div>
    </div>
  );
}
